/* global L */
import $ from 'jquery';

export default class Map {
  
    setupMap(mapData) {
    
        let map = L.map(mapData.mapId, {
            crs: L.CRS.Simple,
            minZoom: 0,
            maxZoom: 0,
            zoomControl: false,
            attributionControl: false,
            dragging: false,
            doubleClickZoom: false,
            boxZoom: false,
            scrollWheelZoom: false,
            touchZoom: false,
        });
    
        map.createPane('locationInfo');
    
        let bounds = [[0,0], [600,1500]];
        L.imageOverlay(mapData.imageUrl, bounds).addTo(map);
        map.fitBounds(bounds);
    
        let myIcon = L.divIcon({
            className: 'pblk-div-icon',
            iconSize: [46, 56],
        });
    
        let infoIcon = L.divIcon({
            className: 'locationInfoMarkerContainer',
            iconSize: [309, 289],
            iconAnchor: L.point(0, 0),
        });
    
        let infoPaneMarker = L.marker([ mapData.popupLocation[0], mapData.popupLocation[1] ], {
            pane: 'locationInfo',
            icon: infoIcon,
            interactive: true,
            html: `<div id="locationInfoContent"></div>`,
        });
    
        let markers = [];
    
        for( let key in mapData.markers ) {
      
            let marker = mapData.markers[key];
      
            let m = L.marker([ marker.lat, marker.lng ], {icon: myIcon}).on('click mouseover', function(){
        
                $(`#${mapData.mapId}`).find('.pblk-div-icon').removeClass('active');
                $(this._icon).addClass('active');
        
                infoPaneMarker.addTo(map);
        
                let $content = $(`<div class='locationInfo'></div>`);
        
                $content.append(`<div class='mapTitle'>${mapData.mapTitle}</div>`);
                $content.append(`<div class='locationName'>${marker.locationName}</div>`);
                $content.append(`<div class='productsMethod'>${marker.productsMethod}:</div>`);
                $content.append(`<div class='productsInfo'>${marker.productsInfo}</div>`);
        
                if (marker.contacts) {
          
                    $content.append(`<div class='contactInfo'>Contact:</div>`);
          
                    for(let contactKey in marker.contacts) {
                        $content.append(`<div class='contactName'>${marker.contacts[contactKey].contactName}</div>`);
                        $content.append(`<div class='contactMethod'>Cell: ${marker.contacts[contactKey].contactCell}</div>`);
                        $content.append(`<div class='contactMethod'>Office: ${marker.contacts[contactKey].contactOffice}</div>`);
                        $content.append(`<div class='contactMethod'><a href='mailto:${marker.contacts[contactKey].contactEmail}'>${marker.contacts[contactKey].contactEmail}</a></div>`);
                    }
                }
        
                $(map.getPane('locationInfo')).find('.locationInfoMarkerContainer').html($content);
        
            }).addTo(map);
      
            markers.push(m);
        }
    
        markers[0]._icon.click();
    
    }
  
    constructor() {
    
        if ( window.PBLK_MAPS ) {
            for( let i = 0; i < window.PBLK_MAPS.length ; i++ ) {
                this.setupMap(window.PBLK_MAPS[i]);
            }
        }
    }
  
}


// WEBPACK FOOTER //
// ./src/js/components/map.js